import React, { useState } from "react";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { SUB_TIER } from "../../../Const";
import { checkSub, isPremiumOrPro } from "../../../utils/SubUtils";
import useInput from "../../hooks/useInput";
import TutorialPopup from "../../help/TutorialPopup";
import ToolTip from "../../help/ToolTip";
import LockedFeature from "../../MarketIntelligence/LockedFeature";

const BotTradedStocks = (props)=>{
    const {template,t}=props
    const TradedStocksByTemplate = useSelector((state)=>state.marketplace.template_traded_stocks) || []
    const subscription =
    useSelector((state) => state.auth.user.user_subscription) || {};
    const email = useSelector((state) => state.auth.user.email);
    const premiumOrPro = isPremiumOrPro(subscription);
    const { subMethod, subPremium, subTier } = checkSub(subscription);
    const paidLite = subPremium && subTier === SUB_TIER.lite && subMethod !== "gift";
    const canAccessStockPerformance = premiumOrPro || paidLite;
    const tradedStocks = TradedStocksByTemplate && TradedStocksByTemplate
    .slice() // Create a shallow copy to avoid mutating the original array
    .sort((a, b) => a.from.localeCompare(b.from)) // Sort alphabetically
    .map((item, index) => {
        const volatilityLabel = item.volatility_week_label
            || (item.volatility_week ? `${item.volatility_week}%` : null);

        return (
        <li  key={index} ><a href="#" onClick={(e)=>{e.preventDefault();props.onStockClick(item)}} style={{color: '#000',backgroundColor: item.color_code}} className="traded-stocks-list-li">
            {volatilityLabel && item.from ? (
                <>
                    {item.from}{" "}
                    <ToolTip content={`Weekly volatility: ${volatilityLabel}`}>
                        <span style={{ cursor: "help" }}>({volatilityLabel})</span>
                    </ToolTip>
                </>
            ) : (
                item.symbol_with_volatility || item.from
            )}
        </a></li>
        );
    });
    return (
        <>
        {canAccessStockPerformance?
        <div className="col-lg-12 m-0">
        <div className="mdc-trade-stock">
            <h4> <img src="/images/trade-icon.svg" alt=""/> Stock Performance Indicator <TutorialPopup content={t("trade-stocks-help")} /> <a href="https://docs.stockhero.ai/getting-started/stock-performance-indicator" target="_blank" rel="noopener noreferrer" style={{fontSize: '14px', marginLeft: '10px',color: "green"}}>Details</a></h4>
            <label>
                The percentage value refers to the Weekly Volatility.  Please read this<a href=" https://docs.stockhero.ai/getting-started/stock-performance-indicator#what-is-a-volatility-index" target="_blank" rel="noopener noreferrer" style={{fontSize: '14px', marginLeft: '3px',color: "green"}}>article</a> for details.</label>
                <ul>
                    {tradedStocks}
                </ul>
                </div>
        </div>
            :
            <div className="col-lg-12 m-0">
                <div className="mdc-trade-stock">
                 <LockedFeature
                    title="Historical Performance Locked"
                    description={<span>Upgrade to a <strong>paid plan</strong> to view historical performance of stocks traded with this strategy.</span>}
                    shadow={false}
                />
                </div>
            </div>
        }
        </>
       
    );
}
export default connect(null,{})(BotTradedStocks)
